import React, { useEffect, useState } from 'react';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import { LightPlayer, Match } from '../../types/types';
import { RenderPriceCell, RenderTeamCell, PopulateMatchRows, MatchTableColumns } from '../../globals/TableFunctions';
import InfoIcon from '@mui/icons-material/Info';
import RemoveIcon from '@mui/icons-material/Remove';
import { useAppSelector, useAppDispatch } from '../../hooks';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { TeamsList, TeamLogos } from '../../globals/Globals';
import { selectChosenPlayerIds, RemovePlayer, AddPlayer,AddPlayerByID } from '../../state/reducers/ChosenPlayersReducer';
import AddIcon from '@mui/icons-material/Add';

import _ from 'underscore';
import { useNavigate } from 'react-router-dom';

export interface Props {
    matches: Match[];
    aboutTeam: string;
}

const MatchesTable = ({matches, aboutTeam}:Props) => {
    const [ rows, setRows ] = useState<object[]>([]);
    const router = useNavigate();

    useEffect(() => {
        setRows(PopulateMatchRows(matches, aboutTeam));
    }, [matches])

    let height = 500;

    const onCellClick = (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        router(`/match/${params.row.matchid}`);
    }

    return <PlayerDataGrid
        height={height}
        columns={MatchTableColumns}
        rows={rows}
        onCellClick={onCellClick}
    />
}

export default MatchesTable;